import { render, staticRenderFns } from "./about4.vue?vue&type=template&id=35d517a2&"
import script from "./about4.vue?vue&type=script&lang=js&"
export * from "./about4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports